// ATENÇÃO: Sempre que um novo campo for adicionado
// set a propriedade visible para false
export default [
  {
    id: 'userName',
    text: 'Usuário / Atendedor',
    title: 'Nome do usuário',
    visible: true
  },
  {
    id: 'extension',
    text: 'Ramal',
    title: 'Número ramal do usuário',
    visible: true
  },
  {
    id: 'department',
    text: 'Departamento',
    title: 'Nome do departamento do usuário / ramal',
    visible: true
  },
  {
    id: 'login',
    text: 'Login',
    title: 'Tempo que o usuário está logado no ramal',
    visible: true
  },
  {
    id: 'status',
    text: 'Estatus',
    title: 'Status atual do usuário no ramal (disponível / pausa)',
    visible: true
  },
  {
    id: 'tStatus',
    text: 'T. Estatus',
    title: 'Tempo do usuário no status',
    visible: true
  },
  {
    id: 'lastRec',
    text: 'Ultima Grav.',
    title: 'Ultima gravação deste ramal',
    visible: false
  },
  {
    id: 'total',
    text: 'Total',
    title: 'Chamadas que o usuário fez parte (recebidas e executadas)',
    visible: false
  },
  {
    id: 'outgoing',
    text: 'Saintes',
    title: 'Chamadas que fez para destinos externos (clientes, etc...)',
    visible: false
  },
  {
    id: 'internal',
    text: 'Internas',
    title: 'Internas que o usuário fez parte (recebidas e executadas)',
    visible: false
  },
  {
    id: 'internalOut',
    text: 'Internas Feitas',
    title: 'Internas executadas (ramal-ramal / ramal-grupo)',
    visible: false
  },
  {
    id: 'internalIn',
    text: 'Internas Recebidas',
    title: 'Internas recebidas (ramal-ramal / ramal-grupo)',
    visible: false
  },
  {
    id: 'received',
    text: 'Recebidas',
    title: 'Recebidas pelo ramal/usuário (internas e externas)',
    visible: true
  },
  {
    id: 'made',
    text: 'Executadas',
    title: 'Feitas pelo ramal/usuário (internas e externas)',
    visible: true
  },
  {
    id: 'incoming',
    text: 'Entrada',
    title: 'Recebidas de origem externa',
    visible: true
  },
  {
    id: 'ttring',
    text: 'T. ring(P)',
    title: 'Tempo total de espera em ring',
    visible: false
  },
  {
    id: 'avgring',
    text: 'TM. ring(P)',
    title: 'Tempo médio de espera em ring',
    visible: false
  },
  {
    id: 'minring',
    text: 'Min. ring(P)',
    title: 'Menor tempo de espera em ring',
    visible: false
  },
  {
    id: 'maxring',
    text: 'Max. ring(P)',
    title: 'Maior tempo de espera em ring',
    visible: false
  },
  {
    id: 'answered',
    text: 'Atendidas',
    title: 'Chamadas atendidas de quais quer origem (internas e externas)',
    visible: false
  },
  {
    id: 'transferred',
    text: 'Transferidas',
    title:
      'Ligações que foram transferidas por este operador, grupo, departamento, etc. Para outro destino',
    visible: true
  },
  {
    id: 'answeredIn',
    text: 'Externas Atendidas',
    title: 'Atendidas de origem externas',
    visible: false
  },
  {
    id: 'pctAnswered',
    text: '% Atendidas',
    title: '%Atendidas',
    visible: false
  },
  {
    id: 'ttanswer',
    text: 'T. atendimento(P)',
    title: 'Tempo total de atendimento do usuário no ramal',
    visible: false
  },
  {
    id: 'avganswer',
    text: 'TM. atendimento(P)',
    title: 'Tempo médio de atendimento do usuário no ramal',
    visible: true
  },
  {
    id: 'minanswer',
    text: 'Mix. atendimento(P)',
    title: 'Menor tempo de atendimento do usuário no ramal',
    visible: false
  },
  {
    id: 'maxanswer',
    text: 'Max. atendimento(P)',
    title: 'Maior tempo de atendimento do usuário no ramal',
    visible: false
  },
  {
    id: 'notAnswered',
    text: 'Não Atendidas',
    title: 'Chamadas recebidas e não foram atendidas',
    visible: true
  },
  {
    id: 'pctNotAnswered',
    text: '% Não Atendidas',
    title: '%Não Atendidas',
    visible: false
  },
  {
    id: 'callPickup',
    text: 'Capturadas',
    title: 'Atendimentos a partir de captura',
    visible: true
  },
  {
    id: 'client',
    text: 'Cliente',
    title: 'Cliente da última ligação',
    visible: true
  },
  {
    id: 'call',
    text: 'Sentido',
    title: 'Sentido da última ligação (Feita, recebida, nenhum)',
    visible: false
  },
  {
    id: 'extStatus',
    text: 'Estatus Ramal',
    title: 'Estatus do ramal neste momento (ring, atendimento, falha, etc)',
    visible: true
  },
  {
    id: 'extStatusTime',
    text: 'T.Estatus Ramal',
    title: 'Tempo em que o ramal está no status atual',
    visible: false
  },
  {
    id: 'scores',
    text: 'Chamadas Avaliadas',
    title: 'Quantidade de chamadas avalidas pelo cliente',
    visible: false
  },
  {
    id: 'score',
    text: 'Nota Total',
    title: 'Soma das notas de chamadas avalidas pelo cliente',
    visible: false
  },
  {
    id: 'avgscore',
    text: 'Nota Média',
    title: 'Média das notas recebidas',
    visible: false
  },
  {
    id: 'minscore',
    text: 'Menor Nota',
    title: 'Menor nota recebida',
    visible: false
  },
  {
    id: 'maxscore',
    text: 'Maior Nota',
    title: 'Maior nota recebida',
    visible: false
  }
];
